import React, { useEffect, useRef, useState } from "react";
import Box from "../../../../components/_styles/Box";
import { PageTitle } from "../../../../styles";
import styled from "styled-components";
import { ReactComponent as Search } from "../../../../assets/search.svg";
import { useHistory, useLocation } from "react-router-dom";
import { getMessagesTemplates } from "../../../../actions/radminUploads";
import { useDispatch } from "react-redux";
import { HeaderContainer } from "../../Cohorts/Create";
import Flex from "../../../../components/_styles/Flex";
import { useFormik } from "formik";
import TemplateData from "./TemplateData";

const SwitchContainer = styled.div`
  display: flex;
  background: #e6e9f1;
  border-radius: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #0c2945;
  width: fit-content;
  margin-top: 30px;
`;

const SwitchButton = styled.button`
  padding: 7px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.active ? "#0C2945" : "#E6E9F1")};
  color: ${(props) => (props.active ? "#F9FAFC" : "#0C2945")};
  font-weight: ${(props) => (props.active ? 700 : 600)};
  border: 0;
  outline: 0;
  border-radius: 6px;
`;

const FormContainer = styled(Flex)`
  justify-content: space-between;
`;
const InputContainer = styled.div`
  width: 450px;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    width: 350px;
  }
  @media (max-width: 957px) {
    margin-top: 5px;
  }
`;

const ClearButton = styled.button`
  position: absolute;
  margin-left: 410px;
  border-radius: 5%;
  z-index: 1;
  border: none;
  cursor: pointer;
  color: #000000;
  background-color: transparent;
  transform: translateX(2px);
  @media (max-width: 768px) {
    margin-left: -30px;
  }
`;

const SearchIcon = styled.i`
  display: inline-block;
  position: absolute;
  margin-left: 10px;
  color: green;
  min-width: 45px;
  @media (max-width: 768px) {
    margin-left: 10px;
  }
`;
const Input = styled.input`
  width: 450px;
  background: #ffffff;
  border: 1px solid #dfe0eb;
  border-radius: 5px;
  height: 43.5px;
  padding-left: 35px;
  font: normal 16px "Open Sans", sans-serif;
`;

const CustomPlaceholder = styled.span`
  position: absolute;
  margin-left: 40px;
  font-family: Open Sans, sans-serif;
  font-size: 14px;
  color: #000000;
  @media (max-width: 768px) {
    margin-left: 60px;
  }
`;

const tabOption = [
  { label: "SMS", value: "sms" },
  { label: "Email", value: "email" },
  { label: "Fax", value: "fax" },
];
const templateSubTab = [
  { label: "Manual", value: "manual" },
  { label: "Automatic", value: "automatic" },
];

const Template = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const mounted = useRef();
  const debounceTimeout = useRef(null);
  const inputRef = useRef(null);
  const queryParams = new URLSearchParams(props.location.search);
  const tabFromUrl = queryParams.get("tab");
  const tabSubUrl = queryParams.get("type");
  const title = queryParams.get("title");
  const [activeTab, setActiveTab] = useState(tabFromUrl ?? "sms");
  const [page, setPage] = useState(1);
  const [titleForSearch, setTitleForSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeSubTab, setActiveSubTab] = useState(tabSubUrl ?? "manual");
  const [showPlaceholder, setShowPlaceholder] = useState(
    titleForSearch ? false : true
  );

  const getMesageData = async () => {
    setLoading(true);
    if (activeTab) {
      if (title) {
        setTitleForSearch(title);
        setShowPlaceholder(false);
        formik.setFieldValue("titleForSearch", title);
        await dispatch(
          getMessagesTemplates(page, activeTab, activeSubTab, title)
        );
      } else {
        await dispatch(
          getMessagesTemplates(page, activeTab, activeSubTab, titleForSearch)
        );
      }
    }
    setLoading(false);
  };

  const handleInputChange = async () => {
    setLoading(true);

    await dispatch(
      getMessagesTemplates(
        1,
        activeTab,
        activeSubTab,
        formik.values.titleForSearch
      )
    );
    setPage(1);
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      titleForSearch: titleForSearch || "",
      titleForSearchRad: titleForSearch || "",
    },
  });

  const onShowPlaceholder = () => {
    if (!inputRef.current.value) {
      setShowPlaceholder(true);
    }
  };

  const onHidePlaceholder = () => {
    setShowPlaceholder(false);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setTitleForSearch(formik.values.titleForSearch);
    handleInputChange();
  };

  const updateURLParams = (paramsToUpdate) => {
    const params = new URLSearchParams(location.search);

    Object.keys(paramsToUpdate).forEach((key) => {
      if (paramsToUpdate[key] !== undefined && paramsToUpdate[key] !== "") {
        params.set(key, paramsToUpdate[key]);
      } else {
        params.delete(key);
      }
    });

    history.replace({ search: params.toString() });
  };

  const onTabClick = (tab, subTab, title = "", page = 1) => {
    setPage(page);
    setTitleForSearch(title);
    formik.setFieldValue("titleForSearch", title);
    updateURLParams({
      tab: tab,
      type: tab === "sms" ? subTab : "",
      title: title,
    });
  };

  const onResetForm = () => {
    setLoading(true);
    formik.setFieldValue("titleForSearch", "");
    setShowPlaceholder(true);
    setTitleForSearch("");
    onTabClick(activeTab, activeSubTab, "", 1);
    dispatch(getMessagesTemplates(1, activeTab, activeSubTab, "")).then(
      (response) => {
        if (response) {
          setLoading(false);
        }
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    getMesageData();
  }, [activeTab, activeSubTab]);

  useEffect(() => {
    if (!tabFromUrl) {
      updateURLParams({
        tab: activeTab || "sms",
        type: activeSubTab || "manual",
      });
    }
  }, []);

  return (
    <Box p={30}>
      <HeaderContainer>
        <PageTitle>{`${
          activeTab === "sms" ? "Message" : activeTab
        } Templates`}</PageTitle>
        <FormContainer>
          <form onSubmit={handleSearchSubmit}>
            <InputContainer>
              <SearchIcon>
                <Search />
              </SearchIcon>
              {showPlaceholder && (
                <>
                  <CustomPlaceholder onClick={onHidePlaceholder}>
                    {`Search by ${
                      activeTab !== "fax"
                        ? "campaign title or template name"
                        : "cover page id or cover page name"
                    }`}
                  </CustomPlaceholder>
                </>
              )}
              <Input
                type="text"
                id={"titleForSearch"}
                name={"titleForSearch"}
                onFocus={onHidePlaceholder}
                onBlur={onShowPlaceholder}
                onChange={(e) => {
                  setLoading(true);
                  formik.handleChange(e);
                  const updatedValue = e.target.value;
                  setTitleForSearch(updatedValue);
                  updateURLParams({
                    tab: activeTab,
                    type: activeTab === "sms" ? activeSubTab : "",
                    title: updatedValue,
                  });
                  if (!updatedValue) {
                    dispatch(
                      getMessagesTemplates(1, activeTab, activeSubTab, "")
                    ).then((response) => {
                      if (response?.results) {
                        setLoading(false);
                      }
                    });
                  }
                }}
                value={formik.values.titleForSearch}
                ref={inputRef}
              />
              {!showPlaceholder && formik.values.titleForSearch && (
                <ClearButton type={"reset"} onClick={onResetForm}>
                  X
                </ClearButton>
              )}
            </InputContainer>
          </form>
        </FormContainer>
      </HeaderContainer>
      <SwitchContainer>
        {tabOption.map((tab) => (
          <SwitchButton
            active={activeTab === tab.value}
            onClick={() => {
              window.analytics.track(`Messages-${tab.label}-Click`);
              setActiveTab(tab.value);
              onTabClick(tab.value, "manual", "", 1);
              setLoading(true);
              setShowPlaceholder(true);
              setActiveSubTab("manual");
            }}
          >
            {tab.label}
          </SwitchButton>
        ))}
      </SwitchContainer>

      {activeTab === "sms" && (
        <SwitchContainer style={{ marginTop: "20px" }}>
          {templateSubTab.map((subTab) => (
            <SwitchButton
              active={activeSubTab === subTab.value}
              onClick={() => {
                window.analytics.track(`Messages-${subTab.label}-Click`);
                setActiveSubTab(subTab.value);
                onTabClick(activeTab, subTab.value, "", 1);
              }}
            >
              {subTab.label}
            </SwitchButton>
          ))}
        </SwitchContainer>
      )}

      <Box>
        <TemplateData
          activeTab={activeTab}
          titleForSearch={titleForSearch}
          setTitleForSearch={setTitleForSearch}
          page={page}
          setLoading={setLoading}
          loading={loading}
          setPage={setPage}
          activeSubTab={activeSubTab}
        />
      </Box>
    </Box>
  );
};

export default Template;
